import { CSSObject } from '@chakra-ui/react';

export const OddsText: CSSObject = {
  fontSize: 'sm',
  fontWeight: 'extrabold',
  color: 'white',
};
export const MultiCardContainer: CSSObject = {
  borderTop: '1px solid',
  borderColor: 'blackAlpha.300',
  boxShadow: '0px 1px 0px 0px rgba(255, 255, 255, 0.15) inset',
  mx: '2.5',
  py: '2',
  px: '0.5',
};
export const OddsMultiCard: CSSObject = {
  fontWeight: 'semibold',
  color: 'white',
  fontSize: 'xs',
};
